/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import DocumentHead from 'data/document-head';
import Topbar from 'modules/me/topbar';
import SelectSupportPlan from 'modules/me/select-support-plan';
import { Stack, Text, Heading, Box } from '@towersystems/towersystems-design-system';
import { hasScheduledChanges } from 'state/current-support/selectors';

// new
import AnnotatedSection from 'components/annotated-section';
import Button from 'components/button';
import ScheduledChangesNotice from 'modules/me/support/scheduled-changes-notice';

const EditSupport = (props) => {
    return (
        <Box>
            <DocumentHead title='Manage Support Billing - Tower Systems' />
            <Topbar title='Support Plan' subTitle='Manage your support subscription' selected='support'>
                <Button primary link='/dashboard/support'>
                    View Subscription Details
                </Button>
            </Topbar>
            {props.hasScheduledChanges && (
                <Box marginBottom='xxlarge'>
                    <ScheduledChangesNotice></ScheduledChangesNotice>
                </Box>
            )}
            <Main padding='xxlarge'>
                <Stack space='xxlarge'>
                    <Box>
                        <Heading level='3'>Select a support plan</Heading>
                        <Text>
                            *Prices are excluding any applicable discounts. Please click on a support plan below to view
                            the estimated plan price.
                        </Text>
                    </Box>
                    <Box>
                        <SelectSupportPlan />
                    </Box>
                </Stack>
            </Main>
        </Box>
    );
};

export default connect(
    (state) => ({
        hasScheduledChanges: hasScheduledChanges(state),
    }),
    {},
)(EditSupport);
